import React, { useEffect, useState } from 'react';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import Select from 'react-select';

import { GroupingsService, DevicesService, EventConfigurationsService, RolesService, TimeFormattingService, AssetsService } from "../../services";
import PageTitle from '../PageTitle/page_title';
import { EntityGroupingAMTDetail } from '../Grouping';
import { FormatHelper } from '../../helpers';
import i18next from "i18next";

import config from "config";

const SiteReport = () => {
  const [availableGroupingValues, setAvailableGroupingValues] = useState(null);
  const [selectedGrouping, setSelectedGrouping] = useState(null);
  const [areasToDevices, setAreasToDevices] = useState(null);
  const [areasToAssets, setAreasToAssets] = useState(null);
  const [groupingWithAMT, setGroupingWithAMT] = useState(null);
  const [eventConfigurations, setEventConfigurations] = useState(null);
  const [devices, setDevices] = useState(null);
  const [assets, setAssets] = useState(null);
  const [loading, setLoading] = useState(null);
  const [actions, setActions] = useState(null);
  const [rolesToUsers, setRolesToUsers] = useState(null);

  useEffect(() => {
    GroupingsService.listAll().then((response) => {
      const parentIds = response.groupings.map(grouping => grouping.parent ? grouping.parent.id : null);
      setAvailableGroupingValues(
          response.groupings.filter((grouping) => grouping.parent !== null && !parentIds.includes(grouping.id)).map((grouping) => ({ value: grouping.id, label: grouping.name, grouping: grouping }))
      );
    }).catch((error) => {
      // TODO setErrorMessage(i18next.t('messages.could-not-load-grouping'));
      console.error(error);
    });    
  }, []);

  const renderContact = (actionResult) => {
    switch (actionResult.actionResultType.token) {
      case 'ad_hoc_email':
      case 'ad_hoc_voice':
        return actionResult.value;
      case 'ad_hoc_sms':
          let sms = actionResult.value;
          return `+${sms.charAt(0)} (${sms.substring(1,4)}) ${sms.substring(4,7)}-${sms.substring(7)}`;
      default:
        return "";
    }
  };

  useEffect(() => {
    if (selectedGrouping && rolesToUsers) {
      setLoading(true);

      let requests = [];

      requests.push(EventConfigurationsService.getEventConfigurationsForGrouping(selectedGrouping.value).then((response) => {
        let actions = []
        response.eventConfigurations.forEach(config => {
          config.alertConfigurationActions.forEach(configAction => {
            if (!actions.some(action => action.id === configAction.action.id)) {
              actions.push(configAction.action)
            }
          })
        })
        let customActions = []
        actions.forEach(action => {
          let logObj = {name: action.name, type: "Log", distributionGroup: "", members: null}
          customActions.push(logObj);
          action.actionResults.forEach(result => {
            if (!result.archived && result.actionResultType.name !== 'Log') {              
              customActions.push({
                name: action.name, 
                type: result.actionResultType.name, 
                distributionGroup: result.role ? result.role.name : "", 
                members: result.role ? rolesToUsers[result.role.id].join(", ") : renderContact(result)
              });
            }
          })
        })

        setEventConfigurations(response.eventConfigurations);
        setActions(customActions);
      }));

      requests.push(DevicesService.listAllForGrouping(selectedGrouping.value).then((response) => setDevices(response.devices)));

      requests.push(AssetsService.listAllForGrouping(selectedGrouping.value).then((response) => {
        let localAreasToAssets = [];

        setAssets(response.assets);

        response.assets.forEach((asset) => {
          const curArea = asset.tags.filter((tag) => tag.tagType.token == "area")[0] ?? { name :"Other" };
          if (localAreasToAssets[curArea.name]) {
            localAreasToAssets[curArea.name].push(asset);
          } else {
            localAreasToAssets[curArea.name] = [asset];
          }
        });

        if (Object.entries(localAreasToAssets).length > 0) {
          setAreasToAssets(localAreasToAssets);
        } else {
          setAreasToAssets(null);
        }
      }));


      requests.push(GroupingsService.get(selectedGrouping.value, true).then((response) => {
        let localAreasToDevices = [];
        for (let i = 0; i < response.grouping.amtDevices.floor_plan_location.length; i++) {
          let curDevice = response.grouping.amtDevices.floor_plan_location[i]
          let metadata = curDevice.deviceMetadata.filter(data => data.deviceMetadataType.name === "location_x" || data.deviceMetadataType.name === "location_y")
          if (metadata.length === 2 && metadata[0].numericValue && metadata[1].numericValue) {
            let curArea = curDevice.tags.filter(tag => tag.tagType.token === "area")[0]
            if (curArea == null) {
              curArea = {name :"Other"}
            }
            if (localAreasToDevices[curArea.name]) {
              localAreasToDevices[curArea.name][localAreasToDevices[curArea.name].length] = curDevice
            } else {
              localAreasToDevices[curArea.name] = [curDevice]
            }
          }
        }
        
        setGroupingWithAMT(response.grouping);
        setAreasToDevices(localAreasToDevices);
      }));

      Promise.all(requests).then((_) => {
        setLoading(false);
      }).catch((error) => {
          // TODO setErrorMessage(i18next.t("messages.could-not-load-configurations-grouping"));
          // TODO setErrorMessage(i18next.t("messages.could-not-load-devices-grouping"));
          // TODO setErrorMessage(i18next.t('messages.could-not-load-grouping-map'));
          setLoading(false);
          console.error(error);
      });
    }
  }, [selectedGrouping, rolesToUsers]);

  const onSubmit = () => {
    if (selectedGrouping) {
      setLoading(true);

      RolesService.rolesToUsers(selectedGrouping.value).then((response) => {
        setEventConfigurations(null);
        setGroupingWithAMT(null);
        setDevices(null);
        setAssets(null);
        setActions(null);
        setRolesToUsers(response.roles);
        setLoading(false);
      }).catch((error) => {
        // TODO setErrorMessage(i18next.t('messages.could-not-load-users-grouping'));
        setLoading(false);
        console.error(error);
      });
    }
  };
    
  const sortByEvaluationValue = (a, b) => {
    let evalA = a.displayableEvaluationNumericValue ? a.displayableEvaluationNumericValue : a.displayableEvaluationStringValue.toLowerCase();
    let evalB = b.displayableEvaluationNumericValue ? b.displayableEvaluationNumericValue : b.displayableEvaluationStringValue.toLowerCase();

    return (evalA === evalB) ? 0 : (evalA > evalB ? 1 : -1);
  };  

  return (
      <div className="device-detail-report">
          <div className="row">
              <PageTitle title={i18next.t("pages.site-report.header")} />
          </div>
          {availableGroupingValues ? (
              <div className="op-content-box filter-box" style={{ marginBottom: 20 }}>
                  <ul className="list-inline clearfix">
                      <li className="pull-left box-label">
                          <h4 className="remove-margin-bottom">{i18next.t("filters")}</h4>
                      </li>
                  </ul>
                  <div className="row">
                      <div className="col-sm-3">
                          <label>{i18next.t("form-labels.location")}</label>
                          <Select
                              options={availableGroupingValues}
                              clearable={false}
                              value={selectedGrouping}
                              onChange={(value) => setSelectedGrouping(value)}
                              searchable={false}
                              classNamePrefix="react-select"
                              placeholder={i18next.t("form-labels.select-location")}
                          />
                      </div>
                      <div className="pull-left">
                          <label style={{ visibility: "hidden" }}>{i18next.t("form-labels.run")}</label>
                          <ul className="list-inline clearfix">
                              <li className="pull-left" style={{ marginLeft: "15px" }}>
                                  <button type="submit" onClick={onSubmit} className="btn btn-sm btn-default pull-right">
                                      {i18next.t("form-labels.run")}
                                  </button>
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>
          ) : (
              <div className="loader">{i18next.t("loading")}</div>
          )}

          {areasToDevices && groupingWithAMT && (
              <div className="op-content-box filter-box" style={{ marginBottom: 20 }}>
                  <ul className="list-inline clearfix">
                      <li className="pull-left box-label">
                          <h4 className="remove-margin-bottom">Devices</h4>
                      </li>
                  </ul>
                <div className="row">
                  <div className=" monitoring-location-map">
                      <div style={{ marginTop: 15 }}>
                          <EntityGroupingAMTDetail areasToEntities={areasToDevices} grouping={groupingWithAMT} />
                      </div>
                  </div>
                </div>
              </div>
          )}

          {areasToAssets && groupingWithAMT && (
              <div className="op-content-box filter-box" style={{ marginBottom: 20 }}>
                  <ul className="list-inline clearfix">
                      <li className="pull-left box-label">
                          <h4 className="remove-margin-bottom">Assets</h4>
                      </li>
                  </ul>
                <div className="row">
                  <div className="monitoring-location-map">
                      <div style={{ marginTop: 15 }}>
                          <EntityGroupingAMTDetail areasToEntities={areasToAssets} grouping={groupingWithAMT} />
                      </div>
                  </div>
                </div>
              </div>
          )}

          {eventConfigurations && groupingWithAMT && devices && assets ? (
            <div className="op-content-box filter-box" style={{ marginBottom: 20 }}>
                  <ul className="list-inline clearfix">
                      <li className="pull-left box-label">
                          <h4 className="remove-margin-bottom">Alert Configurations</h4>
                      </li>
                  </ul>
              <div className="row">
                <div style={{paddingLeft: 20, paddingRight: 20}}>
                  {eventConfigurations.map((eventConfiguration, index) => (
                      <div key={index} style={index !== 0 ? { marginTop: "30px" } : null} className="react-table-custom">
                          <h3 style={{ marginBottom: "5px" }}>
                              {" "}
                              {eventConfiguration.name} [{eventConfiguration.alertConfigurationStatus.name}]{" "}
                          </h3>

                          <ExemptTimesArea alertExemptTimes={eventConfiguration.alertExemptTimes} />

                          <ReactTable
                              className="-striped -highlight"
                              showPagination={false}
                              data={eventConfiguration.alertConfigurationActions}
                              columns={[
                                  {
                                      Header: i18next.t("table-headers.threshold"),
                                      accessor: "threshold",
                                      sortable: true,
                                      Cell: (cell) => <MeasurementCell data={cell} />,
                                      width: 250,
                                      sortMethod: sortByEvaluationValue,
                                      minResizeWidth: 50,
                                  },
                                  {
                                      Header: i18next.t("table-headers.duration-minutes"),
                                      accessor: "duration",
                                      Cell: (cell) => <div> {cell.value / 60} </div>,
                                      sortable: true,
                                      width: 200,
                                      minResizeWidth: 50,
                                  },
                                  {
                                      Header: i18next.t("table-headers.level"),
                                      accessor: "alertLevel.token",
                                      Cell: (cell) => i18next.t(`alert-levels.${cell.value}`),
                                      sortable: true,
                                      width: 200,
                                      minResizeWidth: 50,
                                  },
                                  {
                                      Header: i18next.t("table-headers.assets"),
                                      accessor: "threshold.tags",
                                      Cell: (cell) => <EntityCell tags={cell.value} devices={devices} assets={assets} />,
                                      sortable: false,
                                      style: { whiteSpace: "unset" },
                                      width: 300,
                                      minResizeWidth: 50,
                                  },
                                  {
                                      Header: i18next.t("table-headers.action"),
                                      accessor: "action.name",
                                      sortable: true,
                                      minResizeWidth: 50,
                                  },
                              ]}
                          />
                      </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
              loading && <div className="loader">{i18next.t("loading")}</div>
          )}

          {eventConfigurations && groupingWithAMT && devices && actions && rolesToUsers && (
            <div className="op-content-box filter-box" style={{ marginBottom: 20 }}>
              <ul className="list-inline clearfix">
                  <li className="pull-left box-label">
                      <h4 className="remove-margin-bottom">{i18next.t("pages.site-report.actions")}</h4>
                  </li>
              </ul>
              <div className="row">
                <div style={{paddingLeft: 20, paddingRight: 20}}>
                  <div className="react-table-custom site-report-table">
                      <ReactTable
                          className="-striped -highlight"
                          data={actions}
                          pivotBy={["name"]}
                          showPagination={false}
                          expanded={actions.map((_) => true)}
                          columns={[
                              {
                                  Header: i18next.t("table-headers.action"),
                                  accessor: "name",
                                  width: 250,
                                  sortable: true,
                                  minResizeWidth: 50,
                              },
                              {
                                  Header: i18next.t("table-headers.type"),
                                  accessor: "type",
                                  aggregate: (_) => "",
                                  width: 235,
                                  sortable: true,
                                  minResizeWidth: 50,
                              },
                              {
                                  Header: i18next.t("table-headers.distribution-group"),
                                  accessor: "distributionGroup",
                                  aggregate: (_) => "",
                                  sortable: true,
                                  minResizeWidth: 50,
                              },
                              {
                                  Header: i18next.t("table-headers.location-members"),
                                  accessor: "members",
                                  aggregate: (_) => "",
                                  style: { whiteSpace: "unset" },
                                  sortable: true,
                                  width: 500,
                                  minResizeWidth: 50,
                              },
                          ]}
                      />
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
  );
}

const ExemptTimesArea = ({alertExemptTimes}) => {
  const exemptTimes = alertExemptTimes
    .filter((exemptTime) => !exemptTime.archived)
    .map((exemptTime) => TimeFormattingService.secondsToHoursMinutes(exemptTime.startAtTime) + " - " + TimeFormattingService.secondsToHoursMinutes(exemptTime.endAtTime));

  return exemptTimes.length > 0 ? (
    <p>
      {" "}
      ({i18next.t("pages.site-report.exempt-times")} {exemptTimes.join(', ')}){" "}
    </p>
  ) : null;
};

const EntityCell = ({tags, devices, assets}) => {
  let entityString = ""
  devices.forEach(device => {
    if (device.tags.filter(deviceTag => tags.some(tag => tag.id === deviceTag.id)).length > 0) {
      entityString += device.displayName + ", ";
    }
  });

  assets.forEach(asset => {
    if (asset.tags.filter(assetTag => tags.some(tag => tag.id === assetTag.id)).length > 0) {
      entityString += asset.name + ", ";
    }
  });

  if (entityString.length > 0) {
    entityString = entityString.substr(0, entityString.length - 2);
  }

  return <div> {entityString} </div>;
};

const MeasurementCell = ({data}) => {
  let row = data.value;
  let imgsrc = `${config.WEB_BASE_URL}/images/icon/sensor_${row.thresholdClassification.token}.svg`;
  let iconReference = <img src={imgsrc} height="16" alt={i18next.t('measurement-icon')}/>;
  let evaluationValue = FormatHelper.formatMeasurement(row);

  if (row.deviceDataType) {
    return (
        <span>
            {iconReference} {row.deviceDataType.name} <span className="threshold-evaluation">{row.thresholdEvaluationType.shortForm}</span> {evaluationValue}
        </span>
    );
  } else if (row.deviceDataClassification) {
    return (
        <span>
            {iconReference} {row.deviceDataClassification.name} <span className="threshold-evaluation">{row.thresholdEvaluationType.shortForm}</span> {evaluationValue}
        </span>
    );
  } else {
    return (
        <span>
            {iconReference} <span className="threshold-evaluation">{row.thresholdEvaluationType.shortForm}</span> {evaluationValue}
        </span>
    );
  }
      
};

export default connect(({currentGrouping}) => ({ currentGrouping: currentGrouping.currentGrouping }))(SiteReport);
